<template>
  <button class="button-wrapper" @click="$emit('select')">
    <div class="card" :class="selected ? 'card-selected' : '' ">
      <div class="card-info">
          <span>{{namePt1}}</span>
      </div>
      <img :src="`${previewsServer + models}previews/models/${data.type.name}.jpg`" alt="">
    </div>
  </button>
</template>
<!-- old -->
<!-- <template>
  <button class="button-wrapper" @click="$emit('select')">
    <div class="card" :class="selected ? 'card-selected' : '' ">
      <div class="card-header">
        <img :src="`${previewsServer + models}previews/models/${data.name}.png`" alt="">
      </div>

      <div class="card-info">
        <h3>{{ data.type.name }}</h3>
      </div>
    </div>
  </button>
</template> -->

<script>
  export default {
    name: "TypeCard",

    props: {
      data: Object,
      selected: Boolean,
    },

    computed: {
      namePt1() {
        // return this.data.type.name.split(' ',1)[0]
        // .toUpperCase();
        return this.data.type.name.toUpperCase();
      },
      namePt2() {
        return this.data.type.name.substring(this.data.type.name.indexOf(' ') + 1)
        .toUpperCase();
      },
    },   
   
    data () {
      return {
        models: import.meta.env.VITE_VUE_APP_MODELS_LOCATION,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
      }
    },
  }
</script>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 2px;
  border-radius: $radius-l;
  transition: outline-color 100ms ease;
  border: none;
  background-color: $c-border-1;
  height: 200px;
  // scroll-margin: 160px;//150px;

  &:hover {
    outline-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    padding: 4px;
    background-color: $c-secondary;

    & img {
      border-radius: $radius-l - $radius-s !important;
    }
  }

  &-info {
    position: absolute;
    left: 24px;

    background-color: $c-secondary;
    border-radius: $radius-m;
    margin-top: 16px;  
    border: 2px solid white;
    color: white;
    height: 36px;
    padding: 0px 10px;

    & span {
      font-family: 'Bebas Neue', sans-serif;
      font-weight: 400;
      font-size: 24px;
      letter-spacing: 1px;
      line-height: 36px;
    }
  }

  & img {
    height: 100%;
    width: 100%;
    object-fit: cover;

    border-radius: $radius-l - $radius-s/2;
  }  
}

.button-wrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  width: 100%;
}

@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
</style>
<!-- old -->
<!-- <style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 20px);
  flex-direction: column;
  outline: 3px solid $c-border-1;
  border-radius: $radius-m;
  padding: 10px;
  transition: outline-color 100ms ease;
  border: none;
  background-color: transparent;
  scroll-margin: 150px;

  &:hover {
    outline-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    outline-color: $c-secondary;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    height: 150px;

    & img {
      min-height: 150px;
      max-height: 150px;
      width: 100%;
      object-fit: contain;
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & h3 {
      font-size: 1rem;
      text-align: left;
      margin: 0px;
    }
  }
}

.button-wrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  width: 100%;
}

</style> -->